import React, { useState, useEffect } from 'react';

function DuplicateIdeaModal({ onConfirm, onCancel, originalTitle }) {
  const [duplicateName, setDuplicateName] = useState('');

  useEffect(() => {
    // Set default name when modal opens
    setDuplicateName(`${originalTitle} (Copy)`);
  }, [originalTitle]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (duplicateName.trim()) {
      onConfirm(duplicateName.trim());
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-[var(--bg-secondary)] p-6 rounded-xl shadow-lg max-w-md w-full">
        <h3 className="text-lg font-semibold mb-4 text-[var(--text-primary)]">Duplicate Idea</h3>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-[var(--text-secondary)] mb-2">
              New Idea Name
            </label>
            <input
              type="text"
              className="w-full p-2 border border-gray-300 dark:border-slate-600 rounded-lg text-[var(--text-primary)] bg-[var(--bg-secondary)] focus:ring-2 focus:ring-[var(--secondary)] focus:border-[var(--primary)] transition-all duration-200"
              placeholder="Enter name for duplicated idea"
              value={duplicateName}
              onChange={(e) => setDuplicateName(e.target.value)}
              autoFocus
            />
          </div>
          <div className="flex gap-2 justify-end">
            <button
              type="button"
              className="px-4 py-2 bg-[var(--secondary)] bg-opacity-20 text-[var(--text-primary)] rounded-lg text-sm hover:bg-[var(--secondary)] hover:text-white transition-all duration-200"
              onClick={onCancel}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-[var(--primary)] text-white rounded-lg text-sm hover:bg-[var(--text-secondary)] transition-colors duration-200"
              disabled={!duplicateName.trim()}
            >
              Duplicate
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default DuplicateIdeaModal;
